import React, {useState} from 'react';
import { rbac } from '../index';
import t from '../../../helpers/t';
import {Dropdown, DropdownButton, moment} from "../../../../../vendor";
import {alertsActions, productsActions} from "inbooma-api";
import {Biscuit} from "../../../../utils";
import SortButtons from "./SortButtons";

const Product = (props) => {

    const [product, setProduct] = useState(props.product);
    const onRemoveProduct = (product) => {

        if (confirm(t('really_remove'))) {
            props.dispatch(productsActions.deleteProduct(
                {
                    id: Number(product.id),
                    token: Biscuit.get('token')
                }
            ));
            props.dispatch(alertsActions.addAlert({
                message : t('removed_${a}',{a:t('product')}),
                icon : 'fi fi-trash',
            }));
            props.forceReInit();
        }
    };
    let count = props.count;
    return (
        <>
            {rbac.hasPermission('editProduct') && product.client_id !== 0 && product.client_id !== null && !props.isSorting &&
            <aside className="inb-c-item__actions">
                <DropdownButton id="dropdown-basic-button" title="..." drop="right" menuAlign="bottom" bsPrefix="button round inb-toggle-contingent-dd hover">
                    <ul className="inb-dropdown__list">
                        <li data-inb-action-link="edit">
                            <Dropdown.Item href={"/products/" + product.id}>
                                <i className="fi fi-wrench"></i>
                                {t('edit_${a}', {a: t('product', null, 'capital')})}
                            </Dropdown.Item>
                        </li>

                        <li>
                            <Dropdown.Item href="#" onClick={props.isSorting ? undefined : () => onRemoveProduct(product)}>
                                <i class="fi fi-trash"></i>{t('remove', null, ' capital')}
                            </Dropdown.Item>
                        </li>

                    </ul>
                </DropdownButton>
            </aside>
            }

            <div className="inb-c-item--product__image"
                title="">
                {(product.image !== null && product.image !== '') &&
                <img src={product.image} alt="Contingent image"/>
                }
                {(product.image === null || product.image === '') &&
                <img src="https://inbooma.s3.eu-central-1.amazonaws.com/images/Produkte.PNG" alt="Contingent image"/>
                }
             </div>

        <div className="small-12 column inb-product--name">
          <span className="inb-product--fullname inb-order-big" title="">{  product.name }</span><br />
        </div>

            <div className="small-12 column inb-product--name" style={{paddingTop:"25px"}}>
                <span className="inb-product--fullname inb-order" title="">{(product.client_id === null || product.client_id === 0) ? t('Inbooma Standard Product') : " " } </span><br />
            </div>
        <div className="small-10 small-offset-2 column">
          <div className="inb-product--type" title="">
              <span style={{float:"left",minWidth:"49%"}}>

               { (product.parent_id === 153) ?
                      t('contingents',null,'capital'):(product.parent_id === 154 || product.parent_id === 0)?
                          t('extra options',null,'capital'):t('unknown',null,'capital')}
                  </span>
              {product.client_id !== null &&

                 <div className="sort_order" title="" style={{paddingBottom:"10px"}}>
                       <SortButtons
                          product={product}
                          setProduct={setProduct}
                          last={count}
                          standard={false}
                          dispatch={props.dispatch}
                          forceReInit={props.forceReInit}
                      />
                  </div>

              }
          </div>
        </div>

    </>
    );
};

export default Product;
